import { get as getCookie } from 'es-cookie'

export const getShopIdFromToken = () => {
  const token = getCookie('token')
  if (!token) return null

  try {
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join(''),
    )

    const payload = JSON.parse(jsonPayload)
    // The claim name might be 'ShopId' or 'shopId' or a URI depending on how the backend is configured.
    // Based on the prompt, it's 'ShopId'.
    return payload.ShopId || payload.shopId || payload['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/sid']
  } catch (e) {
    console.error('Failed to decode token', e)
    return null
  }
}
